import { dressCodeOptions, reservationPolicyOptions } from "../../labels";
import { type SubtypeSectionProps, subtypeControls } from "./support";
import { fieldGrid } from "../../components/styles";

export const diningFieldLabels = {
  dressCode: "Dress code",
  reservationPolicy: "Reservations",
  reservationNotes: "Reservation notes",
  typicalSpendAmount: "Typical spend per person",
  typicalSpendCurrency: "Spend currency",
} as const;

export function DiningSection(props: SubtypeSectionProps) {
  const c = subtypeControls(props);
  return (
    <div className={fieldGrid}>
      {c.select("dressCode", diningFieldLabels.dressCode, dressCodeOptions, "Not set")}
      {c.select(
        "reservationPolicy",
        diningFieldLabels.reservationPolicy,
        reservationPolicyOptions,
        "Not set",
      )}
      {c.text("typicalSpendAmount", diningFieldLabels.typicalSpendAmount, {
        hint: "In the currency's main unit, for example 45.50.",
      })}
      {c.text("typicalSpendCurrency", diningFieldLabels.typicalSpendCurrency, {
        maxLength: 3,
        hint: "Three letters, for example EUR.",
      })}
      {c.area("reservationNotes", diningFieldLabels.reservationNotes, { rows: 3, maxLength: 1000 })}
    </div>
  );
}
